import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { KYMW9006Component } from './kymw9006.component';
import { UpdatePasswordService } from './api-services/update-password.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

/**
 * パスワード変更画面 モジュール設定クラス
 *
 * @export KYMW9006Module
 * @class KYMW9006Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    FontAwesomeModule,
  ],
  declarations: [
    KYMW9006Component,
  ],
  providers: [
    UpdatePasswordService
  ]
})
export class KYMW9006Module {

}
